import React, { FC } from 'react';
import { App, Tree } from 'antd';
import type { DataNode, TreeProps } from 'antd/es/tree';
import { getDataFromDrop } from '../../../../helpers/helpers';
import { tablesSlice } from '../../../../TablesSlice';
import { useAppDispatch, useAppSelector } from '../../../../../../core/redux';
import { showNotification } from '../../../../../usersPage/helpers/helpers';

import s from './VisualizationXPathes.module.scss';

interface IVisualizationXPathes {
  gData: DataNode[];
  setCheckedKeys: (data: string[]) => unknown;
  checkedKeys: string[] | { checked: string[]; halfChecked: string[] };
  loop: (
    data: DataNode[],
    key: React.Key,
    callback: (node: DataNode, i: number, data: DataNode[]) => void,
  ) => unknown;
  onExpand: (newExpandedKeys: React.Key[]) => unknown;
  expandedKeys: React.Key[];
  autoExpandParent: boolean;
}

const { setMaxData } = tablesSlice.actions;
export const VisualizationXPathes: FC<IVisualizationXPathes> = ({
  gData,
  setCheckedKeys,
  checkedKeys,
  loop,
  onExpand,
  expandedKeys,
  autoExpandParent,
}) => {
  const { notification } = App.useApp();
  const dispatch = useAppDispatch();

  const { activeBlocksKeys } = useAppSelector((state) => state.tablesSlice);
  const onDragEnter: TreeProps['onDragEnter'] = (info) => {
    console.log('onDragEnter info =================>', info);
  };

  const onCheck: TreeProps['onCheck'] = (checkedKeys, info) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const isCheck = ['ant-tree-checkbox-inner'].includes(info.nativeEvent.target.className);
    if (isCheck) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setCheckedKeys(checkedKeys);
      return;
    }
  };

  const onDrop = (info) => {
    if (!info.node.title.props.blockData.isParent && !info.dropToGap) {
      showNotification(notification, 'Нельзя перенести блок в неродительский блок', ' ', 'error');
      return;
    }
    const dropKey = info.node.key;
    const dragKey = info.dragNode.key;
    const dropPos = info.node.pos.split('-');
    const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
    const data = [...gData];

    // Find dragObject
    let dragObj: DataNode;
    loop(data, dragKey, (item, index, arr) => {
      arr.splice(index, 1);
      dragObj = item;
    });

    if (!info.dropToGap) {
      // Drop on the content
      loop(data, dropKey, (item) => {
        item.children = item.children || [];
        // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
        item.children.unshift(dragObj);
      });
    } else {
      if (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ((info.node as unknown).props.children || []).length > 0 && // Has children
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        (info.node as unknown).props.expanded && // Is expanded
        dropPosition === 1 // On the bottom gap
      ) {
        loop(data, dropKey, (item) => {
          item.children = item.children || [];
          // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
          item.children.unshift(dragObj);
          // in previous version, we use item.children.push(dragObj) to insert the
          // item to the tail of the children
        });
      } else {
        let ar: DataNode[] = [];
        let i: number;
        loop(data, dropKey, (_item, index, arr) => {
          ar = arr;
          i = index;
        });
        if (dropPosition === -1) {
          ar.splice(i!, 0, dragObj!);
        } else {
          ar.splice(i! + 1, 0, dragObj!);
        }
      }
    }

    const newData = getDataFromDrop(data);
    dispatch(setMaxData(newData));
  };

  return (
    <div className={s.VizualuzationXPathes}>
      <Tree
        onExpand={onExpand}
        expandedKeys={expandedKeys}
        autoExpandParent={autoExpandParent}
        className='draggable-tree'
        checkable
        checkedKeys={checkedKeys || []}
        selectable={false}
        onCheck={onCheck}
        draggable
        // showLine
        // blockNode
        onDragEnter={onDragEnter}
        onDragStart={(e) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          const isOpen = activeBlocksKeys.includes(e.node.key);
          if (isOpen) {
            e.event.preventDefault();
          }
        }}
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
        // @ts-ignore
        onDrop={onDrop}
        treeData={gData}
      />
    </div>
  );
};
